<template lang="pug">
    import-layout
      v-layout(row wrap)
        v-flex(xs12)
         import-contacts-reports
</template>

<script>
import ImportLayout from '@/Contacts/components/import/Layout';
import ImportContactsReports from '@/Contacts/components/import/components/reporting/ImportContactsReports';

export default {
  components: {
    ImportLayout,
    ImportContactsReports,
  },
};
</script>